import React from 'react'

import InterestType from './InterestType'
import SplitCard from './SplitCard'
import Variable from './common/Variable'
import Fixed from './common/Fixed'
import CurrentRate from './common/CurrentRate'
import Amount from './SplitCard/Amount'

import {
  numberAddCommas
} from 'servos/formValidations'

class Selection extends React.Component {

  renderVariable() {
    return(
      <Variable
        onChange={ (data) => this.props.onChange({ variable: data }) }
      />
    )
  }

  renderFixed() {
    return(
      <Fixed
        onChange={ (data) => this.props.onChange({ fixed: data }) }
      />
    )
  }

  renderInlineRate() {
    const {
      interestType,
    } = this.props

    switch(interestType) {
      case 'fixed':
        return this.renderFixed()
      case 'variable':
        return this.renderVariable()
      default:
        return null
    }
  }

  onInterestTypeChange = (interestType) => {
    const {
      onChange,
      loanAmount,
    } = this.props

    switch(interestType) {
      case 'fixed':
        onChange({ interestType: interestType, fixed: { fixedAmount: loanAmount }})
        break
      case 'variable':
        onChange({ interestType: interestType, variable: { variableAmount: loanAmount }})
        break
      default:
        onChange({ interestType: interestType })
    }
  }

  handleAmountChange = (value) => {
    const {
      onChange,
      loanAmount,
    } = this.props
    const amount = value === '' ? loanAmount : value
    const fixedAndVariable = {
      fixed: { fixedAmount: amount },
      variable: { variableAmount: loanAmount - amount }
    }
    onChange(fixedAndVariable)
  }

  renderSplit() {
    const {
      onChange,
      loanAmount,
    } = this.props

    return(
      <div>
        <SplitCard
          title='Split 1 - Fixed Rate'
        >
          <Amount
            type='fixed'
            totalAmount={ loanAmount }
            onChange={ (value) => this.handleAmountChange(value)}
          />
          <div className='card-body'>
            { this.renderFixed() }
          </div>
          <CurrentRate interestType="fixed" />
        </SplitCard>
        <SplitCard
          title='Split 2 - Variable Rate'
        >
          <Amount
            type='variable'
            totalAmount={ loanAmount }
          />
          <div className='card-body'>
            { this.renderVariable() }
          </div>
          <CurrentRate interestType="variable" />
        </SplitCard>
      </div>
    )
  }

  render() {
    const {
      interestType,
      loanAmount,
    } = this.props

    return(
      <div>
        <div className='card card-single'>
          <div className='card-body'>
            <p>
              You are borrowing <strong>${ numberAddCommas(loanAmount) }</strong>.
            </p>
            <InterestType
              selected={ interestType }
              onChange={ this.onInterestTypeChange }
            />

            { this.renderInlineRate() }
          </div>
          {
            interestType !== 'split' &&
            <CurrentRate interestType={ interestType } />
          }
        </div>

        { (interestType === 'split') ? this.renderSplit() : null }
      </div>
    )
  }
}

export default Selection
